import(/* webpackMode: "eager" */ "E:\\Final Projects Repo\\LocoBuzzWebsite\\locobuzz-website\\app\\platform\\social-intelligence\\page.js");
